import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=86d78ce2&"
import script from "./Seating.vue?vue&type=script&lang=js&"
export * from "./Seating.vue?vue&type=script&lang=js&"
import style0 from "./Seating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Seating.vue"
export default component.exports